import type { CannedCollectionModuleCard } from '@coursera-web/cds-labs';

import config from 'js/app/config';

import _t from 'i18n!nls/xdp';

export default function getCardTakeoverProps() {
  const newYearPromoStartDate = new Date(2025, 11, 29);
  const isNewYearPromoActive = new Date() >= newYearPromoStartDate;

  const courseraPlusProps: Omit<CannedCollectionModuleCard, 'onClick'> = {
    id: 'coursera-plus-promo-unit',
    eyebrowImage: {
      url: `${config.url.imageProxyRoot}https://images.ctfassets.net/00atxywtfxvd/27RcUlDZHZQ2ZbNPKd3Uuv/f7b95eac743a8ced191475993183a5d7/coursera-plus-logo-invert.svg`,
    },
    headline: isNewYearPromoActive
      ? _t('Next level skills. New Year savings.')
      : _t('Unlimited growth. Unbeatable savings.'),
    cardBackgroundImage: {
      url: isNewYearPromoActive
        ? `${config.url.imageProxyRoot}https://images.ctfassets.net/00atxywtfxvd/55vGSdldvkeYRXslscFNvV/18613468e7569b1d49ef8586d79a8053/NY_Global__High_LTV__50-_CannedCollection-Desktop-374x174.png`
        : `${config.url.imageProxyRoot}https://images.ctfassets.net/00atxywtfxvd/2DPdF3Alzu4m85mIMQ5DS8/f9ef1a9443e95118a17cd1906f0cc60c/EoYSale_Global__High_LTV__50-_CannedCollection-Desktop-374x174.png`,
      width: 600,
      height: 416,
    },
    ctaText: _t('Save on Coursera Plus'),
    target: `${config.url.base}courseraplus/special/new-year-2026-global`,
    backgroundColor: isNewYearPromoActive ? 'dark-blue' : 'dark-red',
    ctaVariant: 'ghostInvert',
    openInNewTab: false,
  };

  const courseraForBusinessProps: Omit<CannedCollectionModuleCard, 'onClick'> = {
    id: 'coursera-for-business-promo-unit',
    eyebrowImage: {
      url: `${config.url.imageProxyRoot}https://images.ctfassets.net/00atxywtfxvd/G4qlahDi3SptCFCAcPvCb/8a92841d88cc36036f058a13da2cfcfd/2_Sub_Brand.png`,
    },
    headline: _t('Drive your business forward and empower your teams'),
    cardBackgroundImage: {
      url: `${config.url.imageProxyRoot}https://images.ctfassets.net/00atxywtfxvd/Cb3tIS562yNwOycYVtgEA/c0ae706313c23a9448476155a3dc31f7/474x328.png`,
      width: 600,
      height: 416,
    },
    ctaText: _t('Try Coursera for Business'),
    target: `${config.url.base}business?utm_campaign=website&utm_content=cardtakeoverbanner&utm_medium=coursera&utm_source=enterprise&utm_term=treatment`,
    backgroundColor: isNewYearPromoActive ? 'primary-blue-xstrong' : 'dark-blue',
    ctaVariant: 'ghostInvert',
    openInNewTab: false,
  };

  return {
    courseraPlusProps,
    courseraForBusinessProps,
  };
}
